export const AWAITING_RESOLUTION = 63;

type LoggedUser = {
  id?: number | string;
  name?: string;
};

export const selectLeafValue = (value: any) => (Array.isArray(value) ? value[value.length - 1] : value) || null;

export function buildSupportServicePayload(values: any, loggedUser: LoggedUser, selectedStatus: number | null) {
  return {
    ...values,
    serviceChannelId: selectLeafValue(values?.serviceChannelId),
    teamId: selectLeafValue(values?.teamId),
    justificationResolutionId: selectLeafValue(values?.justificationResolutionId),
    resolvingAreaId: selectedStatus === AWAITING_RESOLUTION ? selectLeafValue(values?.resolvingAreaId) : null,
    createdByUser: loggedUser?.name,
    createdByUserId: loggedUser?.id,
  };
}
